import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { useFlocknoteAppState } from "Flocknote/state";
import { useCanStax } from "Flocknote/stateHooks";

import Portal from "Utilities/PortalMaker";
import { useDashboardPortalElement } from "Utilities/PortalMaker/useDashboardPortalElement";

import CrisisSystemMessages from "./DashboardMainSections/CrisisSystemMessage/CrisisSystemMessages";
import FundItInfoSplash from "./DashboardMainSections/FundItInfoSplash";
import FundItMemberSplash from "./DashboardMainSections/FundItMemberSplash";
import FundItSignupSplash from "./DashboardMainSections/FundItSignupSplash";
import HouseholdDBSplash from "./DashboardMainSections/HouseholdDBSplash";
// import StaxSignupSplash from "./DashboardMainSections/FundItSignupSplash/StaxSignupSplash";
// import HasEngageSplash from "./DashboardMainSections/HasEngageSplash";
// import NoEngageSplash from "./DashboardMainSections/NoEngageSplash";
import AnimateEntrance from "./DashboardRightSections/AnimateEntrance";

const MainDashboardPortal = ({ settings }) => {
  const [state] = useFlocknoteAppState();
  const [childCount, setChildCount] = useState(0);
  const dashboardMainPortal = useDashboardPortalElement({
    selector: "#dashboard_main_content",
    childCount,
    setChildCount,
    dashboardTick: state.dashboardTick,
  });

  useEffect(() => {
    if (dashboardMainPortal?.childElementCount) {
      setChildCount(dashboardMainPortal.childElementCount);
    }
  }, [dashboardMainPortal]);

  const canStax = useCanStax();
  return (
    <>
      {dashboardMainPortal ? (
        <Portal to={dashboardMainPortal}>
          <AnimateEntrance delay={0} data-cy="MainDashboard_Container">
            <CrisisSystemMessages settings={settings} />

            {!canStax && (
              // {/* For Super Admins: before, during, & 30 days after Fund It setup is complete */}
              <FundItSignupSplash
                status={settings.fundItStatus}
                settings={settings}
              />
            )}

            {/* For Group Admins after Fund It setup, and Super Admins 30 days after Fund It setup */}
            <FundItInfoSplash settings={settings} />

            {/* Fund it Splash for regular members (non-admins) */}
            <FundItMemberSplash
              networkIsSignedUpForPayments={
                settings?.networkIsSignedUpForPayments
              }
              isSuperAdmin={settings?.isSuperAdmin}
              isGroupAdminForAnyGroup={settings?.isGroupAdminForAnyGroup}
              networkName={settings?.networkName}
              hideFundItSplashToRegularUsers={
                settings?.hideFundItSplashToRegularUsers
              }
            />

            <HouseholdDBSplash />

            {/* WOF Engage splash is now encorporated in the Library dashboard module
            Leaving this here for now, but someday we can clean this up. */}
            {/* <HasEngageSplash settings={settings} /> */}
            {/* <NoEngageSplash settings={settings} /> */}
          </AnimateEntrance>
        </Portal>
      ) : null}
    </>
  );
};

MainDashboardPortal.propTypes = {
  settings: PropTypes.object,
};

export default MainDashboardPortal;
